import { Routes, Route } from "react-router-dom";

import Home from "./view/home";
import Studies from "./view/studies";
import ShotExamples from "./view/shot-examples";
import Prompts from "./view/prompts";
import DataSchema from "./view/data-schema";
import SapMethod from "./view/sap-method";


const routes = [
{
  path:"/",element:<Home/>
},
{
  path:"/studies" , element:<Studies/>
},
{
  path:"/shotexamples" , element:<ShotExamples/>
},
{
  path:"/prompts" , element:<Prompts/>
},
{
  path:"/domains" , element:<DataSchema location={"/domains"}/>
},
{
  path:"/pydanticDataSchema" , element:<DataSchema location={"/pydanticDataSchema"}/>
},
{
  path:"/StatisticalAnalysisMethods" , element:<SapMethod/>
},
{
  path:"/test" , element:<h1>testing route...</h1>
}
]

function Router() {
  return (
    <Routes>
       {
        routes.map( item => <Route path={item.path} element={ item.element } /> )
       }
    </Routes>
  );
}

export default Router;
